@if (message$ | async; as message) {
  @if (message?.message?.length > 0) {
    @if (!isMessageHidden(message)) {
      <div class="notification notification-WARNING" id="service-notification">
        <i class="left-side aimo-icon icon-inline icon-WARNING"></i>
        <span class="middle" [innerHTML]="message.message|safeHtml"></span>
        <div class="right-side">
          <i class="aimo-icon icon-petrol-blue icon-inline icon-x float-right" (click)="hideMessage(message)"></i>
        </div>
      </div>
    }
  }
}

@if (isLoggedInUser$ | async) {
  @if (customerBlocked$ | async; as block) {
    <div class="notification notification-ERROR" id="customer-blocked">
      <i class="left-side aimo-icon icon-inline icon-ERROR"></i>
      <span class="middle">
        {{ 'order.error.customerBlocked' | cxTranslate }}
        <a class="link" [routerLink]="'/contact'">{{ 'order.error.customerBlockedContact' | cxTranslate }}</a>
      </span>
    </div>
  }
}
